// "All My Sites Went Down — The Proxy Vanished" — Dokploy/Traefik outage incident.
// Cold Compute / Neon kit. ~135s @ 30fps. Every claim grounded in the real
// 2026-06-10 incident postmortem (docs/incidents/2026-06-10-traefik-outage-postmortem.md).
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames (30fps); contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //          0:00–0:05  all sites down, server fine
  triage: { start: 150, duration: 480 }, //      0:05–0:21  VPS is healthy → not the box
  probe: { start: 630, duration: 480 }, //       0:21–0:37  80/443 open but HTTP hangs
  dockerps: { start: 1110, duration: 540 }, //   0:37–0:55  apps Up, no dokploy-traefik
  proof: { start: 1650, duration: 420 }, //      0:55–1:09  ss :80/:443 → nothing listening
  rootcause: { start: 2070, duration: 600 }, //  1:09–1:29  swarm recovers, traefik doesn't
  fix: { start: 2670, duration: 600 }, //        1:29–1:49  recreate with --restart always
  prevent: { start: 3270, duration: 480 }, //    1:49–2:05  the three preventions
  outro: { start: 3750, duration: 300 }, //      2:05–2:15  the lesson
} as const;

export const TOTAL_DURATION = 4050; // 135s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
